export const formatEnum = (val?: string) => {
    if (!val) return "";
    
    while (val.includes("_")) {
        val = val.replace("_", " ");
    }

    return val;
}